(() => {
  if (App.settings.optimizeQuickReorderAndLogin) return;

  TrackApp.userLogin = (() => {
    const trackUserLogin = function (message = 'login success') {
      const $defer = $.Deferred();
      TrackApp.trackInteraction('user', 'login', message);
      setTimeout(() => {
        $defer.resolve();
      }, 300);
      return $defer;
    };

    return {
      trackUserLogin,
    };
  })();
})();
